import { useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { homeQueryOptions } from "../api/home-query-options";

export function useCities() {
  const { i18n } = useTranslation();
  return useSuspenseQuery({
    ...homeQueryOptions(i18n.language),
    select: (response) => ({ data: response.data.cities }),
  });
}
